import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import DeleteModal from "../../components/Common/DeleteModal"
import { Tooltip } from 'react-tooltip';
import EcommerceOrdersModal from "./EcommerceOrdersModal"
import {
  Col,
  Row,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import classnames from "classnames"
import RejectModal from "./RejectModal"
import AcceptModal from "./AcceptModal"
import OrderCancelledModal from "./OrderCancelledModal"
import TableContainerV1 from "components/Common/TableContainerV1"
import { getOrderList, getOrderStatusCount, updateOrder } from "http/order/order"
import { useNavigate, useLocation } from "react-router-dom"
import ToastDialog from "components/Common/ToastDialog"
import { formatDateTime, formatNumberWithCommas } from "common/utility"
import FullPageLoader from "components/Common/FullPageLoader"
function EcommerceOrder() {
  document.title = "Orders Request List | DMS"
  const navigate = useNavigate()
  const { roleName } = JSON.parse(localStorage.getItem("user"))
  const [customActiveTab, setcustomActiveTab] = useState("1")
  const [modal1, setModal1] = useState(false)
  const [cancelModal, setCancelModal] = useState(false)
  const [cancelData, setCancelData] = useState(null)
  const order = null
  const [allpagination, setAllPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })
  const [pendingpagination, setPendingPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })
  const [processingPagination, setProcessingPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })
  const [processedPagination, setProcessedPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })
  const [rejectedPagination, setRejectedPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })
  const [cancelledPagination, setCancelledPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })
  const [pageSize, setPageSize] = useState(10)
  const [searchValue, setSearchValue] = useState("")
  const [columnId, setColumnId] = useState("id")
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc")
  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["view", "Action", "employee"],
  })
  const [allOrderList, setAllOrderList] = useState([])
  const [pendingOrderList, setPendingOrderList] = useState([])
  const [processingOrderList, setProcessingOrderList] = useState([])
  const [processedOrderList, setProcessedOrderList] = useState([])
  const [rejectOrderList, setRejectOrderList] = useState([])
  const [cancelledOrderList, setCancelledOrderList] = useState([])
  const [activeOrder, setActiveOrder] = useState("all")
  const [acceptOrderId, setAcceptOrderId] = useState(null)
  const [rejectOrderId, setRejectOrderId] = useState(null)
  const [toastInfo, setToastInfo] = useState({ showToast: false })
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const tab = queryParams.get("tab")
  const [deleteModal, setDeleteModal] = useState(false)
  const [acceptModal, setAcceptModal] = useState(false)
  const [rejectModal, setRejectModal] = useState(false)
  const [countStatus, setCountStatus] = useState({})

  const [isUpdateOrder, setIsUpdateOrder] = useState(false)

  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    }
  }

  const toggleViewModal = () => setModal1(!modal1)

  const toogleCancelViewModal = () => {
    if (!cancelModal) {
      setCancelModal(true)
    } else {
      setCancelModal(false)
      setCancelData(null)
    }
  }

  const user = JSON.parse(localStorage.getItem("user"))

  const onClickReject = id => {
    setRejectModal(true)
    setRejectOrderId(id)
  }

  const handleDeleteOrder = () => {
    if (order && order.id) {
      dispatch(onDeleteOrder(order.id))
      setDeleteModal(false)
    }
  }

  const handleRejectOrder = remarks => {
    setRejectModal(false)
    updateOrderStatus("rejected", remarks)
  }

  const handleAcceptOrder = () => {
    setAcceptModal(false)
    updateOrderStatus("accepted")
  }

  const updateOrderStatus = async (orderstatus, remarks = "") => {
    try {
      setIsUpdateOrder(true);
      let res = await updateOrder({
        id: orderstatus === "accepted" ? acceptOrderId : rejectOrderId,
        orderStatus: orderstatus,
        remarks: remarks,
      })
      const { status, message } = res
      if (status) {
        setIsUpdateOrder(false);
        setToastInfo({
          message: message,
          showToast: true,
          role: "success",
        })
      }
      setAcceptOrderId(null)
      setRejectOrderId(null)
      fetchOrderListByStatus("all", setAllOrderList);
      fetchOrderListByStatus("pending", setPendingOrderList)
      fetchOrderListByStatus("processing", setProcessingOrderList)
      fetchOrderListByStatus("processed", setProcessedOrderList)
      fetchOrderListByStatus("rejected", setRejectOrderList)
      fetchOrderListByStatus("cancelled", setCancelledOrderList)
      fetchStatusCount()

    } catch (err) {
      setIsUpdateOrder(false);
      setToastInfo({
        message: err.message,
        showToast: true,
        role: "error",
      })
      setAcceptOrderId(null)
      setRejectOrderId(null)
    }
  }

  const getStatusComponent = (val) => {
    const statusMap = {
      processed: <p className="bg-green rounded-pill status-pill text-white  d-flex justify-content-center p-1">Processed</p>,
      processing: <p className="bg-warning rounded-pill status-pill text-white  d-flex justify-content-center p-1" >Processing</p>,
      rejected: <p className="bg-danger rounded-pill status-pill text-white  d-flex justify-content-center p-1">Rejected</p>,
      pending: <p className="bg-warning rounded-pill status-pill text-white  d-flex justify-content-center p-1" >Pending</p>,
      cancelled: <p className="bg-danger rounded-pill status-pill text-white  d-flex justify-content-center p-1" >Cancelled</p>,
    };

    return statusMap[val] || null;
  };

  const getUploadedByValue = (isUploadedByEmployee) => {
    return isUploadedByEmployee ? 'Employee' : 'Dealer';
  };

  const getEmployeeFullName = (rowData) => {
    if (rowData.isUploadedByEmployee) {
      return rowData.employee?.firstName + ' ' + rowData.employee?.lastName || '';
    } else {
      return '-';
    }
  };

  const getDealerName = (rowData) => {
    return rowData.dealer?.entityName || '-';
  };

  const getViewDetailsComponent = (cellProps, navigate, onClickReject, user) => {
    const orderId = cellProps.row.original.id;

    const handleEditClick = () => {
      navigate(`/${roleName}/orders/${orderId}`);
    };

    const handleRejectClick = () => {
      onClickReject(orderId);
    };

    const buttonText = (cellProps.row.original.orderStatus === "pending" && getApprovePermission(cellProps.row.original, user.id))
      ? "Edit"
      : "View";

    return (
      <>
        <UncontrolledDropdown>
          <DropdownToggle tag="a" className="card-drop">
            <i className="mdi mdi-dots-horizontal font-size-18"></i>
          </DropdownToggle>

          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem
              onClick={handleEditClick}
            >
              <i
                className={`mdi mdi-${buttonText === "View" ? "eye" : "pencil"} font-size-16 text-success me-1`}
                id="edittooltip"
              ></i>
              {buttonText}
            </DropdownItem>
            {(cellProps.row.original.orderStatus === "pending" && getApprovePermission(cellProps.row.original, user.id)) && (
              <DropdownItem
                onClick={handleRejectClick}
              >
                <i
                  className="mdi mdi-close font-size-16 text-danger me-1"
                  id="edittooltip"
                ></i>
                Reject
              </DropdownItem>
            )}
          </DropdownMenu>
        </UncontrolledDropdown>
      </>

    );
  };

  const columns = useMemo(
    () => [
      {
        Header: "Order Request ID",
        accessor: "orderCode",
        width: "150px",
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => cellProps.value || '',
      },
      {
        Header: "Date",
        accessor: "orderDate",
        filterable: true,
        Cell: (cellProps) => formatDateTime(cellProps.value) || '',
      },
      {
        Header: "Total Amount",
        accessor: "totalAmount",
        filterable: true,
        alignRight: true,
        Cell: (cellProps) => (
          <div style={{ textAlign: 'right' }}>
            {formatNumberWithCommas(cellProps.value || 0)}
          </div>
        ),
      },

      {
        Header: "Uploaded By",
        accessor: "isUploadedByEmployee",
        filterable: true,
        Cell: (cellProps) => getUploadedByValue(cellProps.value),
      },
      {
        Header: "Employee Name",
        accessor: "employee",
        filterable: true,
        Cell: (cellProps) => getEmployeeFullName(cellProps.row.original),
      },
      {
        Header: "Dealer Name",
        accessor: "entityName",
        filterable: true,
        Cell: (cellProps) => getDealerName(cellProps.row.original),
      },
      {
        Header: "Status",
        accessor: "orderStatus",
        filterable: true,
        Cell: (cellProps) => getStatusComponent(cellProps.value),
      },
      {
        Header: "Action",
        accessor: "view",
        disableFilters: true,
        Cell: (cellProps) => getViewDetailsComponent(cellProps, navigate, onClickReject, user),
      },
    ],
    []
  );

  const pendinColumns = useMemo(
    () => [
      {
        Header: "Order Request ID",
        accessor: "orderCode",
        width: "150px",
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => cellProps.value || '',
      },
      {
        Header: "Date",
        accessor: "orderDate",
        filterable: true,
        Cell: (cellProps) => formatDateTime(cellProps.value) || '',
      },
      {
        Header: "Total Amount",
        accessor: "totalAmount",
        filterable: true,
        alignRight: true,
        Cell: (cellProps) => (
          <div style={{ textAlign: 'right' }}>
            {formatNumberWithCommas(cellProps.value || 0)}
          </div>
        ),
      },
      {
        Header: "Uploaded By",
        accessor: "isUploadedByEmployee",
        filterable: true,
        Cell: (cellProps) => getUploadedByValue(cellProps.value),
      },
      {
        Header: "Employee Name",
        accessor: "employee",
        filterable: true,
        Cell: (cellProps) => getEmployeeFullName(cellProps.row.original),
      },
      {
        Header: "Dealer Name",
        accessor: "entityName",
        filterable: true,
        Cell: (cellProps) => getDealerName(cellProps.row.original),
      },
      {
        Header: "Status",
        accessor: "orderStatus",
        filterable: true,
        Cell: (cellProps) => getStatusComponent(cellProps.value),
      },
      {
        Header: "Action",
        accessor: "view",
        disableFilters: true,
        Cell: (cellProps) => getViewDetailsComponent(cellProps, navigate, onClickReject, user),
      },
    ],
    []
  )

  const rejectColumns = useMemo(
    () => [
      {
        Header: "Order Request ID",
        accessor: "orderCode",
        width: "150px",
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => cellProps.value || '',
      },
      {
        Header: "Date",
        accessor: "orderDate",
        filterable: true,
        Cell: (cellProps) => formatDateTime(cellProps.value) || '',
      },
      {
        Header: "Total Amount",
        accessor: "totalAmount",
        filterable: true,
        alignRight: true,
        Cell: (cellProps) => (
          <div style={{ textAlign: 'right' }}>
            {formatNumberWithCommas(cellProps.value || 0)}
          </div>
        ),
      },

      {
        Header: "Uploaded By",
        accessor: "isUploadedByEmployee",
        filterable: true,
        Cell: (cellProps) => getUploadedByValue(cellProps.value),
      },
      {
        Header: "Employee Name",
        accessor: "employee",
        filterable: true,
        Cell: (cellProps) => getEmployeeFullName(cellProps.row.original),
      },
      {
        Header: "Dealer Name",
        accessor: "entityName",
        filterable: true,
        Cell: (cellProps) => getDealerName(cellProps.row.original),
      },
      {
        Header: "Status",
        accessor: "orderStatus",
        filterable: true,
        Cell: (cellProps) => getStatusComponent(cellProps.value),
      },
      {
        Header: "Remarks",
        accessor: "remarks",
        filterable: true,
        width: "250px",
        Cell: cellProps => {
          const maxLength = 50
          const text = cellProps.value || "-"

          const truncatedText = text.length > maxLength
            ? `${text.substring(0, maxLength)}...`
            : text

          return (
            <div>
              <span data-tooltip-id={`my-tooltip-${cellProps?.row.original?.id}`}>{truncatedText}</span>
              <Tooltip
                style={{ maxWidth: '500px', marginLeft: '1rem' }}
                id={`my-tooltip-${cellProps?.row.original?.id}`}
                place="top"
                content={text}
              />
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "view",
        disableFilters: true,
        Cell: (cellProps) => getViewDetailsComponent(cellProps, navigate, onClickReject, user),
      },
    ],
    []
  )

  const handlePageChange = async (
    page,
    pageSize,
    searchKey = searchValue, 
    columnName = columnId,
    sortingOrder = sortingOrderStatus
  ) => {
    setPageSize(pageSize)

    const {
      data: responseData,
      status,
    } = await getOrderList({
      page,
      limit: pageSize,
      searchKey,
      columnName,
      sortingOrder,
      orderStatus: activeOrder,
    })

    if (status) {
      const {
        currentPage,
        totalPages,
        totalItems,
        data: orderList,
      } = responseData

      const paginationStates = {
        all: setAllPagination,
        pending: setPendingPagination,
        processing: setProcessingPagination,
        processed: setProcessedPagination,
        rejected: setRejectedPagination,
        cancelled: setCancelledPagination,
      };

      const paginationSetter = paginationStates[activeOrder];

      if (paginationSetter) {
        paginationSetter({
          pageIndex: currentPage,
          pageCount: totalPages,
          totalRecords: totalItems,
        });
      }

      const orderListSetter = {
        all: setAllOrderList,
        pending: setPendingOrderList,
        processing: setProcessingOrderList,
        processed: setProcessedOrderList,
        rejected: setRejectOrderList,
        cancelled: setCancelledOrderList
      }[activeOrder]

      orderListSetter(orderList)
    } else {
      const orderListSetter = {
        all: setAllOrderList,
        pending: setPendingOrderList,
        processing: setProcessingOrderList,
        processed: setProcessedOrderList,
        rejected: setRejectOrderList,
        cancelled: setCancelledOrderList
      }[activeOrder]

      orderListSetter([])
      const paginationStates = {
        all: setAllPagination,
        pending: setPendingPagination,
        processing: setProcessingPagination,
        processed: setProcessedPagination,
        rejected: setRejectedPagination,
        cancelled: setCancelledPagination,
      };
      const paginationSetter = paginationStates[activeOrder];
      if (paginationSetter) {
      paginationSetter({
        pageIndex: 0,
        pageCount: 0,
        totalRecords: 0,
      });
    }
    }
  }

  const handleSortColumn = option => {
    setSortingOptions(option)

    const columnName = option.column
    setColumnId(columnName)
    const sortingOrder = option.isAsc ? "asc" : "desc"
    setSortingOrderStatus(sortingOrder)
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder)
  }

  const handleSearchFilter = (value, pageSize) => {
    const newValue = value !== undefined ? value : "";
    setSearchValue(newValue);
    handlePageChange(1, pageSize, newValue);
  }

  const handleClearSearch = () => {
    setSearchValue("")
    handlePageChange(1, pageSize, "")
  }

  const fetchOrderListByStatus = async (orderStatus, setOrderList) => {
    try {
      const {
        data: responseData,
        status,
      } = await getOrderList({ orderStatus })

      if (status) {
        const {
          currentPage,
          totalPages,
          totalItems,
          data: orderData,
        } = responseData

        const paginationStates = {
          all: setAllPagination,
          pending: setPendingPagination,
          processing: setProcessingPagination,
          processed: setProcessedPagination,
          rejected: setRejectedPagination,
          cancelled: setCancelledPagination,
        };

        const paginationSetter = paginationStates[orderStatus];

        if (paginationSetter) {
          paginationSetter({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          });
        }


        setOrderList(orderData)
      } else {
        paginationSetter({
          pageIndex: 0,
          pageCount: 0,
          totalRecords: 0,
        });
        setOrderList([])
      }
    } catch (error) {
      console.error(`Error fetching ${orderStatus} order list:`, error.message)
    }
  }


  useEffect(() => {
    fetchOrderListByStatus("all", setAllOrderList)
    fetchOrderListByStatus("pending", setPendingOrderList)
    fetchOrderListByStatus("processing", setProcessingOrderList)
    fetchOrderListByStatus("processed", setProcessedOrderList)
    fetchOrderListByStatus("rejected", setRejectOrderList)
    fetchOrderListByStatus("cancelled", setCancelledOrderList)
  }, [])

  useEffect(() => {
    if (tab) {
      toggleCustom(tab)
    }
  }, [tab])

  const getApprovePermission = (data, id) => {
    try {
      if (data.isUploadedByEmployee) {
        return data.employeeId !== id && checkPermission();
      } else {
        return checkPermissionOrders();
      }
    } catch (error) {
      return false;
    }
  };

  const checkPermission = () => {
    const permissionsStr = localStorage.getItem("permissions")
    const permissions = JSON.parse(permissionsStr)
    const permission = permissions.find(p => p.permission_name == 'bulk_upload_orders')
    if (!permission)
      return false
    else
      return permission['approve_permission'] == 1
  }

  const checkPermissionOrders = () => {
    const permissionsStr = localStorage.getItem("permissions")
    const permissions = JSON.parse(permissionsStr)
    const permission = permissions.find(p => p.permission_name == 'orders')
    if (!permission)
      return false
    else
      return permission['approve_permission'] == 1
  }

  useEffect(() => {
    fetchStatusCount()
  }, [])

  const fetchStatusCount = async () => {
    try {
      let res = await getOrderStatusCount({})
      if (res.status) {
        setCountStatus(res.data)
      }
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <React.Fragment>
      <OrderCancelledModal
        isOpen={cancelModal}
        toggle={toogleCancelViewModal}
        data={cancelData}
      />
      <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setDeleteModal(false)}
      />
      <RejectModal
        show={rejectModal}
        onRejectClick={remarks => {
          handleRejectOrder(remarks)
        }}
        onCloseClick={() => setRejectModal(false)}
      />
      <AcceptModal
        show={acceptModal}
        onAcceptClick={handleAcceptOrder}
        onCloseClick={() => setAcceptModal(false)}
      />
      { isUpdateOrder && <FullPageLoader />}
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Orders" breadcrumbItem="Order Request List" />
          <Col lg={12}>
            <Card>
              <CardBody>
                <Nav tabs className="nav-tabs-custom nav-justified">
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === "1",
                      })}
                      onClick={() => {
                        toggleCustom("1")
                        setActiveOrder("all")
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="fas fa-home"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        All({countStatus.all})
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === "2",
                      })}
                      onClick={() => {
                        toggleCustom("2")
                        setActiveOrder("pending")
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="far fa-user"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        Pending({countStatus.pending || 0})
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === "3",
                      })}
                      onClick={() => {
                        toggleCustom("3")
                        setActiveOrder("processing")
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="far fa-user"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        Processing({countStatus.processing || 0})
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === "4",
                      })}
                      onClick={() => {
                        toggleCustom("4")
                        setActiveOrder("processed")
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="far fa-user"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        Processed({countStatus.processed || 0})
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === "5",
                      })}
                      onClick={() => {
                        toggleCustom("5")
                        setActiveOrder("rejected")
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="far fa-user"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        Rejected({countStatus.rejected || 0})
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === "6",
                      })}
                      onClick={() => {
                        toggleCustom("6")
                        setActiveOrder("cancelled")
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="far fa-user"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        Cancelled({countStatus.cancelled || 0})
                      </span>
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent
                  activeTab={customActiveTab}
                  className="p-3 text-muted"
                >
                  <TabPane tabId="1">
                    <Row>
                      <Col xs="12">
                        <TableContainerV1
                          columns={columns}
                          data={allOrderList}
                          pagination={allpagination}
                          handlePageChange={handlePageChange}
                          handleSearchFilter={handleSearchFilter}
                          // customSection={buttonSection}
                          searchHelperText="Search by Order Request ID"
                          sortOptions={sortingOptions}
                          handleSortColumn={handleSortColumn}
                          handleClearSearch={handleClearSearch}
                          className="custom-header-css"
                          isTab={customActiveTab === "1" ? true : false}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="2">
                    <Row>
                      <Col xs="12">
                        <TableContainerV1
                          columns={pendinColumns}
                          data={pendingOrderList}
                          pagination={pendingpagination}
                          handlePageChange={handlePageChange}
                          handleSearchFilter={handleSearchFilter}
                          // customSection={buttonSection}
                          searchHelperText="Search by Order Request ID"
                          sortOptions={sortingOptions}
                          handleSortColumn={handleSortColumn}
                          handleClearSearch={handleClearSearch}
                          className="custom-header-css"
                          isTab={customActiveTab === "2" ? true : false}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="3">
                    <Row>
                      <Col xs="12">
                        <TableContainerV1
                          columns={columns}
                          data={processingOrderList}
                          pagination={processingPagination}
                          handlePageChange={handlePageChange}
                          handleSearchFilter={handleSearchFilter}
                          searchHelperText="Search by Order Request ID"
                          // customSection={buttonSection}
                          sortOptions={sortingOptions}
                          handleSortColumn={handleSortColumn}
                          handleClearSearch={handleClearSearch}
                          className="custom-header-css"
                          isTab={customActiveTab === "3" ? true : false}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="4">
                    <Row>
                      <Col xs="12">
                        <TableContainerV1
                          columns={columns}
                          data={processedOrderList}
                          pagination={processedPagination}
                          handlePageChange={handlePageChange}
                          handleSearchFilter={handleSearchFilter}
                          // customSection={buttonSection}
                          searchHelperText="Search by Order Request ID"
                          sortOptions={sortingOptions}
                          handleSortColumn={handleSortColumn}
                          handleClearSearch={handleClearSearch}
                          className="custom-header-css"
                          isTab={customActiveTab === "4" ? true : false}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="5">
                    <Row>
                      <Col xs="12">
                        <TableContainerV1
                          columns={rejectColumns}
                          data={rejectOrderList}
                          pagination={rejectedPagination}
                          handlePageChange={handlePageChange}
                          handleSearchFilter={handleSearchFilter}
                          searchHelperText="Search by Order Request ID"
                          // customSection={buttonSection}
                          sortOptions={sortingOptions}
                          handleSortColumn={handleSortColumn}
                          handleClearSearch={handleClearSearch}
                          className="custom-header-css"
                          isTab={customActiveTab === "5" ? true : false}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="6">
                    <Row>
                      <Col xs="12">
                        <TableContainerV1
                          columns={rejectColumns}
                          data={cancelledOrderList}
                          pagination={cancelledPagination}
                          handlePageChange={handlePageChange}
                          searchHelperText="Search by Order Request ID"
                          handleSearchFilter={handleSearchFilter}
                          // customSection={buttonSection}
                          sortOptions={sortingOptions}
                          handleSortColumn={handleSortColumn}
                          handleClearSearch={handleClearSearch}
                          className="custom-header-css"
                          isTab={customActiveTab === "6" ? true : false}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </div>
      </div>
      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
    </React.Fragment>
  )
}
EcommerceOrder.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default EcommerceOrder
